<div class="modal-header mainColor">
    <fa-icon icon = "power-off"></fa-icon>
    <h6 class="modal-title" id="modal-basic-title">¿Está seguro que desea cerrar su sesión?</h6>
    <button type="button" class="close" aria-label="Close" (click)="onDismiss('Cross Click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-footer">
    <button type="button" class="btn dangerButton" (click)="onDismiss('Save click')">Cancelar</button>
    <button type="button" class="btn acceptButton" (click)="onClose('Save click')">Aceptar</button>
</div>
